exports.ById = {
  1: { Name: 'NoInfoOrOnRequest', Id: 1 },
  2: { Name: 'ExactDate', Id: 2 },
  3: { Name: 'YDaysAfterFye', Id: 3 },
  4: { Name: 'XMonthsAfterFye', Id: 4 },
  5: { Name: 'XMonthsOnExactDayAfterFye', Id: 5 },
  6: { Name: 'XMonthsOnLastDayOfMonthAfterFye', Id: 6 },
  7: { Name: 'XMonthsYDaysAfterFye', Id: 7 },
  8: { Name: 'BrazilFormula', Id: 8 },
  9: { Name: 'NewZealandFormula', Id: 9 },
  10: { Name: 'SwedenFormula', Id: 10 }
};

exports.ByName = {
  NoInfoOrOnRequest: { Name: 'NoInfoOrOnRequest', Id: 1 },
  ExactDate: { Name: 'ExactDate', Id: 2 },
  YDaysAfterFye: { Name: 'YDaysAfterFye', Id: 3 },
  XMonthsAfterFye: { Name: 'XMonthsAfterFye', Id: 4 },
  XMonthsOnExactDayAfterFye: { Name: 'XMonthsOnExactDayAfterFye', Id: 5 },
  XMonthsOnLastDayOfMonthAfterFye: { Name: 'XMonthsOnLastDayOfMonthAfterFye', Id: 6 },
  XMonthsYDaysAfterFye: { Name: 'XMonthsYDaysAfterFye', Id: 7 },
  BrazilFormula: { Name: 'BrazilFormula', Id: 8 },
  NewZealandFormula: { Name: 'NewZealandFormula', Id: 9 },
  SwedenFormula: { Name: 'SwedenFormula', Id: 10 }
};
